import React from "react"
import { Link } from "react-router-dom"



const About = () => {
  return (
    <div className=" py-40 md:py-20 bg-accent md:overflow-y-hidden overflow-y-auto ">
      <div className="flex md:flex-row flex-col items-center justify-center w-screen h-[66vh]">
      <div className="flex flex-col items-center justify-center lg:w-2/3 w-full text-white p-4 relative">
          <img 
            src={process.env.PUBLIC_URL + "/g-logo-04.png"} 

            alt="Circe's Forge Logo" 
            className="absolute w-full h-[90vh] object-cover object-center opacity-20" 
          />
          <div className="relative z-10 items-center justify-center">
            <h1 className="text-5xl font-bold mb-6 text-center custom-font-text">ABOUT US</h1>
            <p className="text-xl mb-2 text-center">Welcome to Circe's Forge!</p>
            <p className="text-l mb-1 text-center">Our story began six years ago with a simple click on an Etsy bracelet and a rebellious thought:</p>

            <p className="text-l mb-2 text-center">"I can make this!" </p>
            <p className="text-l text-center mb-2">So began the silversmithing journey of our founder, Keira O'Donnell. 
            With an insatiable curiosity for ancient wisdom, myth, philosophy and symbolism, and after years of perfecting her craft, she finally found her jewellery aesthetic in her passion for ancient Roman and Greek coins.</p>
            <p className="text-l text-center mb-2">Circe's Forge is a Canadian company that specializes in crafting ancient coin jewellery and hand forged chains. These are not just accessories- they are wearable time machines, transporting you to a bygone era where legends were born, and myths came to life. Fueled by a passion for authenticity and an appreciation for the perfectly imperfect, every piece we create is a labour of love. We dive deep into the stories behind the materials, infusing each piece with tales of history and intrigue. Expect a little story, and a bit of whimsy from every treasure you uncover from our collection. </p>
            <p className="text-l text-center mb-2">We sincerely thank you for joining us on this journey. </p>
            <p className="text-l text-center mb-2">Together lets celebrate the art of humanity's ancestors,
            and add a touch of magic to our everyday lives. </p>

          </div>
        </div>
        <div className="flex flex-col items-center justify-center w-1/2 md:pr-16 pt-4">
          <img src={process.env.PUBLIC_URL + "/aboutImage.jpg"} alt="Circe's Forge Logo" className="w-3/4 h-[100vh] object-cover pt-16 hidden md:flex" />
          <Link
            to="/shop"
            className="btn btn-outline text-white border-white flex hover:bg-white hover:text-black mt-6 text-lg px-8"
          >
            Shop Now
          </Link>
        </div>
      </div>
      <div className="absolute left-1/2 transform -translate-x-1/2 w-full md:flex hidden justify-center z-20">
        <Link 
          to="/shop" 
          className="flex items-center justify-between bg-transparent border-2 border-white text-white px-8 py-4 rounded-full hover:bg-white hover:bg-opacity-10 transition-all duration-300"
        >
          
          <span className="w-full text-2xl tracking-widest font-light">
            See our latest creations
          </span>
        </Link>
      </div>
    </div>

  );
};

export default About;

